import ApplicationApiError from "../../../../foundation/ApplicationApiError"
import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { FreeTrialContractView } from "~/backendApis/viewModel"

interface Params {
  universalCorporationId: string
}

export class GetCurrentFreeTrialContractReadRequest extends ReadRequest<FreeTrialContractView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<FreeTrialContractView | null> {
    return this.apiClient
      .get(this.makeEndpoint())
      .catch((e: ApplicationApiError) => {
        if (e.isNotFoundError()) {
          return null
        }
        throw e
      })
  }

  private makeEndpoint(): string {
    const { universalCorporationId } = this.params
    return `/corporation_contract/corporation_member/${universalCorporationId}/free_trial_contract/show`
  }
}
